import { Box, Divider, Grid, IconButton, Typography } from "@mui/material";
import { FC } from "react";
import BackIcon from "../../img/IconArrowBackCircleOutline";

interface Props {
  title?: string;
  titleColor: string;
  imageSrc: string;
  description: string;
  backgroundColorImage: string;
  onBack?: () => void;
  colorIconBack: string;
}

const HeaderAppsMyProjects: FC<Props> = ({
  title,
  titleColor,
  imageSrc,
  description,
  backgroundColorImage,
  onBack,
  colorIconBack,
}) => {
  return (
    <Grid
      container
      sx={{
        width: "100%",
        minHeight: "170px",
        borderRadius: 3,
        backgroundImage: backgroundColorImage,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        p: { xs: 2, md: 3 },
        display: "flex",
        alignItems: "center",
        flexDirection: { xs: "column", md: "row" },
        position: "relative",
        gap: { xs: 4, md: 5 }, 
        mt: { xs: 1, md: 0 },
        flexWrap: "nowrap",
      }}
    >
      {/* Icono de regresar */}
      <Grid item xs={2} sm={1}>
        <IconButton
          onClick={onBack}
          sx={{
            position: "absolute",
            top: { xs: 4, md: 16 },
            left: { xs: 4, md: 16 },
            fontSize: { xs: "1rem", sm: "1.5rem", md: "2rem" },
          }}
        >
          <BackIcon color={colorIconBack} />
        </IconButton>
      </Grid>

      {/* Imagen */}
      <Grid item xs={10} sm={4} md={3}>
        <Box
          component="img"
          src={imageSrc}
          alt="Imagen de cabecera"
          sx={{
            maxWidth: { xs: "150px", sm: "200px", md: "250px" },
            height: "auto",
            objectFit: "contain",
            aspectRatio: 4 / 3,
            width: "100%",
          }}
        />
      </Grid>

      {/* Título y descripción */}
      <Grid
        item
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          alignItems: { xs: "center", md: "flex-start" },
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          color={titleColor}
          fontFamily="Montserrat"
          textAlign={{ xs: "center", md: "left" }}
          sx={{
            fontSize: { xs: "1.25rem", sm: "2rem", md: "3rem", lg: "4rem" },
          }}
        >
          {title}
        </Typography>
        <Divider
          sx={{
            width: { xs: "50px", md: "60px" },
            height: "4px",
            backgroundColor: titleColor,
            borderRadius: 2,
          }}
        />
        <Typography
          variant="body1"
          color="rgba(0, 0, 0, 0.6)"
          fontSize={{
            xs: "0.9rem",
            sm: "1.1rem",
            md: "1.3rem",
            lg: "1.5rem",
          }}
          sx={{
            fontWeight: "medium",
            fontFamily: "Montserrat",
            textAlign: { xs: "center", md: "left" },
            lineHeight: { xs: 1.2, md: 1.4 },
            maxWidth: { xs: "100%", xl: "70%" },
          }}
        >
          {description}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default HeaderAppsMyProjects;
